import { createClient } from '@supabase/supabase-js'
import type { Session } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env['VITE_SUPABASE_URL'] as string
const supabaseAnonKey = import.meta.env['VITE_SUPABASE_ANON_KEY'] as string

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Auth timing race fix:
// beforeLoad in _authenticated.tsx runs before onAuthStateChange fires on
// first page load. Without this promise, authenticated users navigating
// directly to protected routes get kicked to /entrar.
let resolveAuthReady: () => void
export const authReady = new Promise<void>((resolve) => {
  resolveAuthReady = resolve
})

supabase.auth.onAuthStateChange(() => {
  resolveAuthReady()
})

export async function getSession(): Promise<Session | null> {
  const { data } = await supabase.auth.getSession()
  return data.session
}

export async function signOut(): Promise<void> {
  await supabase.auth.signOut()
}

// Open redirect protection — required before launch.
// Only allows same-origin relative paths.
export function validateRedirect(value: string): string | null {
  if (!value || !value.startsWith('/') || value.startsWith('//')) return null
  try {
    const url = new URL(value, window.location.origin)
    return url.origin === window.location.origin ? url.pathname + url.search : null
  } catch {
    return null
  }
}
